import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { Blocks, LegalText, SiteFrame } from '@/types/content'

import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { LegalPageContent } from '@/components/sections/legal-page'
import { REVALIDATE_SECONDS, getLegalText, getPageContent } from '@/lib/content'

interface PrivacyPageProps {
    frame: SiteFrame
    blocks: Blocks
    legal: LegalText | null
}

const PrivacyPage: FC<PrivacyPageProps> = ({ frame, blocks, legal }): ReactNode => {
    const seo = blocks['datenschutz.seo']

    return (
        <Layout frame={frame} showClosing={false}>
            <Seo
                title={seo?.ueberschrift ?? 'Datenschutz'}
                description={seo?.text ?? undefined}
                siteUrl={frame.settings.webseite}
                path='/datenschutz'
            />

            <LegalPageContent legal={legal} fallbackTitle='Datenschutzerklärung' />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<PrivacyPageProps> = async () => {
    const [content, legal] = await Promise.all([
        getPageContent({ blocks: ['datenschutz.seo'] }),
        getLegalText('datenschutz')
    ])

    return {
        props: { frame: content.frame, blocks: content.blocks, legal },
        revalidate: REVALIDATE_SECONDS
    }
}

export default PrivacyPage
